import React from 'react';

const  Error = ({message}) => ( 
            <p className="my-3 p-4 text-center text-white alert btn-warning">{message}</p>
);
  
 
export default Error;